// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailAppProcess_wrapper__6eEz9","col":"DetailAppProcess_col__NLNv3"};